module.exports = __webpack_public_path__ + "static/media/default-user.071cc137.png";